module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.multPmts), function(n, index) {
    return _c('b-row', {
      key: index,
      staticClass: "py-1"
    }, [(index === _vm.multPmts.length - 1) ? _c('form-read-group-label-input', {
      attrs: {
        "isMandatory": true,
        "idLabel": _vm.$t('common.amnt'),
        "placeholderValue": 'Amount (' + _vm.ccy + ')',
        "inputValue": parseFloat(parseFloat(n.amount).toFixed(2)).toString(),
        "type": "number"
      }
    }) : _c('form-write-group-label-input', {
      attrs: {
        "isMandatory": true,
        "idLabel": _vm.$t('common.amnt'),
        "placeholderValue": _vm.$t('common.amnt') + ' (' + _vm.ccy + ')',
        "inputType": "number"
      },
      model: {
        value: (n.amount),
        callback: function($$v) {
          _vm.$set(n, "amount", $$v)
        },
        expression: "n.amount"
      }
    }), _vm._v(" "), _c('form-write-group-label-input', {
      attrs: {
        "isMandatory": true,
        "idLabel": _vm.$t('common.date_label'),
        "placeholderValue": _vm.$t('common.slct_date'),
        "inputType": 'date',
        "id": 'negotiationDateInput' + index
      },
      model: {
        value: (n.date),
        callback: function($$v) {
          _vm.$set(n, "date", $$v)
        },
        expression: "n.date"
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row justify-content-end"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('div', {
    staticStyle: {
      "text-align": "right",
      "font-weight": "bold",
      "font-size": "12px",
      "width": "100%"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('regles_metier.rqstng')) + " "), _c('font', {
    attrs: {
      "color": _vm.sumColor
    }
  }, [_vm._v(_vm._s(_vm.sum + _vm.ccy))]), _vm._v(" " + _vm._s(_vm.$t('regles_metier.of_label')) + "\n          "), _vm._v(" "), _c('font', {
    attrs: {
      "color": "#12bcf1"
    }
  }, [_vm._v(_vm._s(_vm.amount == '' ? '0' + _vm.ccy : _vm.amount + _vm.ccy))])], 1)])])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-36ad2707", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36ad2707","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/EcheancierForm.vue
// module id = 1651
// module chunks = 2